export default "__VITE_ASSET__BmJh11Z2__"